import { Picker, PickerContent, PickerTrigger } from '@/components/widgets/o/Form/Picker';

import { OpacitySlider } from './OpacitySlider';

export const LayerEditMenu = () => {
  return (
    <Picker>
      <PickerTrigger>
        <i className='ri-stack-line' />
      </PickerTrigger>
      <PickerContent>
        <OpacitySlider />
      </PickerContent>
    </Picker>
  );
};
